import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_URI;

export async function fetchCountries() {
  const response = await axios.get("/plg/countries");
  return response.data;
}

export async function fetchUniversesWithRetailers(countryCode) {
  const url = `/plg/universes-with-retailers?country-code=${countryCode}`;
  const response = await axios.get(url);
  return response.data;
}

export async function createUser(signupData) {
  const response = await axios.post("/plg/create-user", signupData);
  return response.data;
}

export async function sendExitForm(exitForm) {
  const response = await axios.post("/plg/send-exit-form", exitForm);
  return response.data;
}
